import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 44,
  height: 25,
}

const Couch = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 44.041 24.619'
  >
    <path
      fill={color}
      d='M41.858,119.632h-.875V116.38a3.49,3.49,0,0,0-3.486-3.486H24.862a3.484,3.484,0,0,0-2.841,1.47,3.483,3.483,0,0,0-2.841-1.47H11.241a.645.645,0,1,0,0,1.29h7.938a2.2,2.2,0,0,1,2.2,2.2v6.452l-.041-.038a4.218,4.218,0,0,0-2.847-1.124H7.741a2.212,2.212,0,0,0-1.462-1.917,2.144,2.144,0,0,0-.716-.121H4.348V116.38a2.2,2.2,0,0,1,2.2-2.2H8.661a.645.645,0,1,0,0-1.29H6.544a3.49,3.49,0,0,0-3.486,3.486v3.252H2.183A2.185,2.185,0,0,0,0,121.815v6.736A4.551,4.551,0,0,0,4.545,133.1H4.87L4.163,135a1.884,1.884,0,0,0,1.748,2.515H6.949a1.875,1.875,0,0,0,1.488-.74l2.781-3.677H32.823l2.781,3.677a1.875,1.875,0,0,0,1.487.74H38.13A1.883,1.883,0,0,0,39.878,135l-.707-1.9H39.5a4.551,4.551,0,0,0,4.545-4.546v-6.736A2.185,2.185,0,0,0,41.858,119.632Zm-19.193-3.252a2.2,2.2,0,0,1,2.2-2.2H37.5a2.2,2.2,0,0,1,2.2,2.2v3.252H38.478a2.234,2.234,0,0,0-2.013,1.34,2.169,2.169,0,0,0-.165.7H25.554a4.232,4.232,0,0,0-2.889,1.162v-6.452Zm-14.92,6.58H18.487a2.892,2.892,0,0,1,2.889,2.889v.917H7.745Zm-.338,13.034a.578.578,0,0,1-.459.228H5.911a.58.58,0,0,1-.539-.775l.874-2.351H9.6Zm30.722.228H37.092a.578.578,0,0,1-.459-.228l-2.192-2.9h3.353l.874,2.351A.58.58,0,0,1,38.13,136.223Zm1.366-4.417H4.545a3.259,3.259,0,0,1-3.255-3.255v-6.736a.893.893,0,0,1,.892-.892h3.38a.893.893,0,0,1,.892.892v5.6a.645.645,0,0,0,.645.645H30.8a.645.645,0,1,0,0-1.29h-8.13v-.917a2.892,2.892,0,0,1,2.889-2.889H36.3v3.806H33.376a.645.645,0,1,0,0,1.29h3.564a.645.645,0,0,0,.645-.645v-5.6a.893.893,0,0,1,.892-.892h3.38a.893.893,0,0,1,.892.892v6.736h0A3.259,3.259,0,0,1,39.5,131.806Z'
      transform='translate(0 -112.894)'
    />
  </svg>
)

export default Couch
